import apiDB from './api_db';
import connect_api from "../connect/connect_api";

class subscribersAPI extends apiDB {
    options(company_id) {
        let self = this;
        const action_types = {
            success: this.action_prefix + "_OPTIONS",
        };
        connect_api.sPOST(
            "/" + this.api_module + "/field_options",
            { company_id },
            function (error, response) {
                self.parseResponse(error, response, action_types);
            }
        );
    }
}

let subscribers = new subscribersAPI({
    api_module: 'subscribers',
    table_key_name: 'subscriber_id',
    reducer_name: 'subscriberR',
    reducer_var: 'subscriber',
    action_prefix: 'SUBSCRIBER'
});

export default subscribers;